import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SettingsLayout } from "../../screens/settings/index.ts";

/**
 * `/settings`: the one layout every Settings page shares (the docked sidebar on desktop). The people pages live in
 * `settings.<page>.tsx` next to this file; plan, billing and Guardian mount here too. A page is a child route:
 * its own file, `<SettingsBar>` for the slim bar, `<SettingsPage>` for the column.
 */
export const Route = createFileRoute("/_app/settings")({
  component: SettingsRoute,
});

function SettingsRoute() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
